// extracted by mini-css-extract-plugin
export default {"container":"container__2LXX7"};
    if(module.hot) {
      // 1764953375274
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  